import React, { useState } from 'react';
import { SOCIAL_MEDIA } from '../../constant/constant';
import './SocialMediaLinks.css';

const SocialMediaLinks: React.FC = () => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);

  const handleMouseEnter = (id: string) => {
    setHoveredItem(id);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  const handleClick = (socialMedia: typeof SOCIAL_MEDIA[0]) => {
    window.open(socialMedia.webURl, '_blank');
  };

  return (
    <div className="social-media-container">
      <h2 className="social-media-title">Connect With Us</h2>
      <p className="social-media-subtitle">Follow us on social media for updates and more content</p>
      
      <div className="social-media-links">
        {SOCIAL_MEDIA.map((socialMedia) => (
          <div 
            key={socialMedia.id}
            className={`social-media-item ${hoveredItem === socialMedia.id ? 'hovered' : ''}`}
            onMouseEnter={() => handleMouseEnter(socialMedia.id)}
            onMouseLeave={handleMouseLeave}
            onClick={() => handleClick(socialMedia)}
          >
            <div className="social-media-icon-container">
              <img 
                src={socialMedia.icon} 
                alt={socialMedia.id} 
                className="social-media-icon"
              />
            </div>
            <div className="social-media-info">
              <h3 className="social-media-name">{socialMedia.id}</h3>
              <p className="social-media-link">{socialMedia.webURl}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialMediaLinks;
